import { useCallback } from 'react'

import { Wrapper, TextField, IconSearch, IconEmpty, ButtonFilter } from './Styled'

interface SearchFieldProps {
  placeholder?: string
  disabled?: boolean
  onSearch?: (value: string) => void
  onRemoveContent?: () => void
  value?: string
  onChange?: (value: string) => void
  [key: string]: any
}

/** 元件 - 搜尋片名的Input框 */
export default function SearchField({
  placeholder = '输入关键字搜寻',
  disabled,
  onSearch,
  onRemoveContent,

  value = '',
  onChange,

  ...otherProps
}: SearchFieldProps) {
  const onSubmit = useCallback(
    (e?: { preventDefault?: () => void }) => {
      e?.preventDefault?.()
      onSearch?.(value)
    },
    [onSearch, value]
  )

  const onWrappedRemoveContent = useCallback(() => {
    onRemoveContent?.()
  }, [onRemoveContent])

  const onWrappedChange = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(ev.currentTarget.value)
    },
    [onChange]
  )

  const onEnter = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        onSubmit()
        e.preventDefault()
      }
    },
    [onSubmit]
  )

  return (
    <>
      <Wrapper {...otherProps} onSubmit={onSubmit}>
        <TextField
          type={'text'}
          placeholder={placeholder}
          value={value}
          onChange={onWrappedChange}
          onKeyDown={onEnter}
        />
        {value ? <IconEmpty onClick={onWrappedRemoveContent} /> : <IconSearch />}
      </Wrapper>
      <ButtonFilter onClick={onSubmit}>搜索</ButtonFilter>
    </>
  )
}
